<div class="modal-backdrop">
  <div class="modal-container" style="max-width: 90vw; width: auto;">
    <div class="modal">
      <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center;">
        <h3 class="modal-title">
          <mat-icon>compare_arrows</mat-icon>
          Comparação de Resultados
        </h3>
        <button mat-icon-button (click)="close()" aria-label="Fechar comparação">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-dialog-content class="modal-body">
        <div class="comparison-container">
          <table class="comparison-table">
            <thead>
              <tr class="header-row">
                <th class="field-label-cell">Campo</th>
                @for (item of items(); track item.id) {
                  <th class="item-cell">{{ item.data.id }}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (field of comparisonFields(); track field.key) {
                <tr [class.has-difference]="field.hasDifference">
                  <td class="field-label-cell">
                    <span>{{ field.label }}</span>
                    @if (field.hasDifference) {
                      <mat-icon class="difference-icon" 
                                matTooltip="Este campo possui diferenças entre os itens"
                                aria-label="Campo com diferenças">
                        info
                      </mat-icon>
                    }
                  </td>
                  @for (item of items(); track item.id; let i = $index) {
                    <td class="item-cell" [class.different-value]="field.hasDifference">
                      @if (field.key === 'status') {
                        <mat-chip>{{ formatValue(field, i) | enumDescription }}</mat-chip>
                      } @else {
                        <span>{{ formatValue(field, i) }}</span>
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>

          <!-- Legenda -->
          <div class="legend">
            <div class="legend-item">
              <mat-icon class="difference-icon">info</mat-icon>
              <span>Campos destacados possuem diferenças entre os itens</span>
            </div>
          </div>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-footer" align="end">
        <button mat-button (click)="close()">Fechar</button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
